import React from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
//Comentario
const FormCompanions = ({ 
    index,
    dataCompanion,
    errors,
    handlerDocumentNumber,
    handlerTypeCompanion,
    handlerName,
    handlerFirstTelephone,
    handlerSecondTelephone,
    handlerRelationship,
    disabled
}) => {

    return (<div>
        <TextField
            required
            style={{ margin: 10, width: 200 }}
            id="document-number-standard-required"
            label="N° de documento"
            type="number"
            disabled={disabled}
            value={dataCompanion.number}
            onChange={(e) => {
                handlerDocumentNumber(index, e.target.value);
            }}
            error={(errors !== null && errors !== undefined) ? (errors[index].hasOwnProperty("number") ? errors[index].number !== "" : false) : false}
            helperText={(errors !== null && errors !== undefined) ? errors[index].number : null}
        />
        <TextField
            required
            style={{ margin: 10, width: 200 }}
            id="name-standard-required"
            label="nombre completo"
            type="text"
            disabled={disabled}
            value={dataCompanion.name}
            onChange={(e) => {
                handlerName(index, e.target.value);
            }}
            error={(errors !== null && errors !== undefined) ? (errors[index].hasOwnProperty("name") ? errors[index].name !== "" : false) : false}
            helperText={(errors !== null && errors !== undefined) ? errors[index].name : null}
        />
        <TextField
            required
            style={{ margin: 10, width: 200 }}
            id="telephone-standard-required"
            label="1° Teléfono "
            type="number"
            disabled={disabled}
            value={dataCompanion.firstTelephone}
            onChange={(e) => {
                handlerFirstTelephone(index, e.target.value);
            }}
            error={(errors !== null && errors !== undefined) ? (errors[index].hasOwnProperty("firstTelephone") ? errors[index].firstTelephone !== "" : false) : false}
            helperText={(errors != null && errors !== undefined) ? errors[index].firstTelephone : null}
        />
        <TextField
            style={{ margin: 10, width: 200 }}
            id="telephone-standard-required"
            label="2° Teléfono "
            type="number"
            disabled={disabled}
            value={dataCompanion.secondTelephone}
            onChange={(e) => {
                handlerSecondTelephone(index, e.target.value);
            }}
        />
        <FormControl
            style={{ margin: 10, width: 200 }}
            error={(errors !== null && errors !== undefined) ? (errors[index].hasOwnProperty("relationship") ? errors[index].relationship !== "" : false) : false}
        >
            <InputLabel id="relationship-status-select-label">Parentesco</InputLabel>
            <Select
                labelId="relationship-select-label"
                id="id-simple-select"
                defaultValue={null}
                disabled={disabled}
                value={dataCompanion.relationship}
                onChange={(event) => {
                    handlerRelationship(index, event.target.value);
                }}
                error={(errors !== null && errors !== undefined) ? (errors[index].hasOwnProperty("relationship") ? errors[index].relationship !== "" : false) : false}
            >
                <MenuItem key={0} value={'otro'}>OTRO</MenuItem>
                <MenuItem key={1} value={'Padre'}>PADRE</MenuItem>
                <MenuItem key={2} value={'madre'}>MADRE</MenuItem>
                <MenuItem key={3} value={'abuelo'}>ABUELO</MenuItem>
                <MenuItem key={4} value={'conyuge'}>CONYUGE</MenuItem>
            </Select>
            <FormHelperText>{(errors !== null && errors !== undefined) ? errors[index].relationship : null}</FormHelperText>
        </FormControl>
    </div>)

}

export default FormCompanions;